"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../cache/index");
/**Crea un objecto para consumir un servicio RPC, en donde las peticiones se realizan en la forma:
 * base/controller/method?params=...
 */
exports.rpcService = (request) => (controller) => async (method, params, body) => await request({
    body: body,
    headers: undefined,
    method: "POST",
    url: "/" + controller + "/" + method,
    urlParameters: params
});
/**
 * Devuelve un crud service para un servicio RPC-POST con la siguiente firma:
 * Get(id : number) => T;
 * Query() => T[];
 * Add(entity: T) => number;
 * Update(entity: T) => number;
 * Delete(id: number) => void;
 *
 * Si su servicio no conforma con esta forma es mejor usar directamente los metodos rpcService.
 * Si el resultado del Update del controllador no devuelve un numero se devuelve el valor de la propiedad IdRegistro del parametro de la función
 */
function rpcCrudService(controller) {
    const get = (id) => controller("Get", { id });
    const resource = index_1.cacheResource({
        get: get,
        getMemo: get,
        query: () => controller("Query"),
        add: (entity) => controller("Add", {}, entity),
        update: async (entity) => {
            const ret = await controller("Update", {}, entity);
            return ret || entity.IdRegistro;
        },
        delete: (id) => controller("Delete", { id })
    }, 
    //Memoizados:
    {
        getMemo: true,
        query: 2
    }, 
    //Invalidan:
    {
        add: true,
        delete: true,
        update: true,
    });
    return resource;
}
exports.rpcCrudService = rpcCrudService;
//# sourceMappingURL=rpc.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/http/rpc.js
// module id = 2270
// module chunks = 0